<template>
	<el-input
		style="width: 200px"
		:placeholder="data.name || '请输入内容'"
		v-model="input"
		clearable
		@input="handleInput"
		@clear="handleClear"
		@keydown.enter="handleEnter"
	>
	</el-input>
</template>

<script>
import { ref } from "@vue/reactivity";
import { inject } from "@vue/runtime-core";
export default {
	props: {
		data: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	setup(props) {
		const updateSearchOption = inject("updateSearchOption");
		const handleSearch = inject("handleSearch");
		let input = ref("");
		const { data } = props;
		const handleInput = (val) => {
			updateSearchOption(data.key, val);
		};

		const handleClear = () => {
			updateSearchOption(data.key, "");
		};

		const handleEnter = () => {
			handleSearch();
		};
		return {
			handleClear,
			handleEnter,
			handleInput,
			input,
		};
	},
};
</script>

<style scoped>
</style>
